import "../css/app.css";

import Alpine from 'alpinejs';
import 'htmx.org';
import intersect from '@alpinejs/intersect';
import collapse from '@alpinejs/collapse';
import focus from '@alpinejs/focus';

Alpine.plugin(intersect);
Alpine.plugin(collapse);
Alpine.plugin(focus);
window.Alpine = Alpine;

import.meta.glob("./components/*.js", { eager: true });

// Main asset dirs
import.meta.glob([
    '../img/**',
    '../static/**',
    '../fonts/**',
]);

Alpine.start();

document.documentElement.classList.remove("no-js");
